import React from 'react';
import TaskDesign from 'components/Task/TaskDesign';


export default React.forwardRef((props, ref) => (
  <TaskDesign {...props} ref={ref} />
));
